import React from 'react'

export default function Header() {
    return (
        <div className="row">
            <div className="col-sm-6 col-sm-offset-3">
                <h1 className="module-title font-alt">Checkout</h1>
            </div>
        </div>
    )
}
